'use client'

import { useFormikContext } from 'formik'
import { Badge } from '@/components/ui/badge'
import { SectionCard } from './fields'
import type { PlanEditorValues } from './model'
import { buildCompactSummary } from './summary-model'
import { formatPlanValue } from './change-format'
import { useTranslations } from "next-intl"
import { useCreditFormatters } from "@/hooks/use-credit-formatters"
import { usePlanPresentation } from "./use-plan-presentation"



export function PlanSummary() {
  const presentation = usePlanPresentation()
  const { formatCredits } = useCreditFormatters()

  const tUi = useTranslations("Billing.BillingPlanEditorPlanSummary")

  const { values } = useFormikContext<PlanEditorValues>()
  return (
    <SectionCard title={tUi("planSummary")}>
      <div className="space-y-2">
        <p className="break-words font-semibold">{values.display_name || presentation.t('newPlan')}</p>
        <div className="flex flex-wrap gap-2">
          <Badge variant="secondary">{formatPlanValue('status', values.status, presentation)}</Badge>
          <Badge variant="outline">{formatPlanValue('billing_channel', values.billing_channel, presentation)}</Badge>
        </div>
      </div>
      <dl className="grid grid-cols-2 gap-x-4 gap-y-3 text-sm">
        {buildCompactSummary(values, presentation, formatCredits).map(row => (
          <div key={row.label} className="min-w-0">
            <dt className="text-xs text-muted-foreground">{row.label}</dt>
            <dd className="mt-0.5 break-words font-medium">{row.value}</dd>
          </div>
        ))}
      </dl>
    </SectionCard>
  )
}
